import { render, staticRenderFns } from "./Fornitori.vue?vue&type=template&id=6fe7e8ba&scoped=true&"
import script from "./Fornitori.vue?vue&type=script&lang=js&"
export * from "./Fornitori.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe7e8ba",
  null
  
)

export default component.exports